// extracted by mini-css-extract-plugin
export var editButtonTitle = "partenaires-module--edit-button-title--1bd12";
export var listPartenairesContainer = "partenaires-module--list-partenaires-container--4814b";
export var partenaireDescription = "partenaires-module--partenaire-description--e6a9e";
export var partenaireItemDescription = "partenaires-module--partenaire-item-description--60d1d";
export var partenairesContainer = "partenaires-module--partenaires-container--713dc";
export var partenairesTitle = "partenaires-module--partenaires-title--26d09";